import { ServicePromotionType } from 'core/constants';
import { ChildModel, ModelBase } from 'store/model-base';
import { PlanPromoSubGroup } from './service-plan-promo-sub-group';

export class ServicePlanPromo extends ModelBase {

    public id: string;
    public type: ServicePromotionType;
    public value: number;
    public valueTotal: number;
    public costByUnlimitedSubgroup: PlanPromoSubGroup[];
    public promoBOID: string;
    public term: number;

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'planPromoSubGroup',
            model: PlanPromoSubGroup
        }];
    }
}